import React, {Suspense, useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next"
import { useNavigate } from 'react-router-dom'; 
import { setFilters, resetFilters} from 'reducers/filtersArticlesSlice';
import { resetPagination } from 'reducers/paginationArticlesSlice';
import { NON_ERASABLE_ARTICLES_ID, ENDPOINT } from "constants/variables";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Container  from '@mui/material/Container';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button'; 
import Checkbox from  '@mui/material/Checkbox';
import "css/generalSettings.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingArticle from 'pages/articles/SortingTablesArticles';
import PropTypes from 'prop-types';

const initialFiltersArticle= {
  "idFrom":"",
  "idTo":"",
  "codeFrom":"",
  "codeTo":"",
  "nameesFrom":"",
  "nameesTo":"",
  "nameenFrom":"",
  "nameenTo":"",
  "enabled":true,
  "notenabled":true,
  "typeinside":true,
  "typeoutside":true,
  "ticketweight":true,
  "tickenotweight":true,
  "typesoftaxFromES":"",
  "typesoftaxToES":"",
  "typesoftaxFromEN":"",
  "typesoftaxToEN":"",
  "codelerFrom":"",
  "codelerTo":""  
};

const initialTypesOfTaxesToSelect = [{
  "id": "",
  "namees": "",
  "nameen": ""
}];

const initialCodeLERToSelect = [{
  "id": "",
  "code":"",
  "namees": "",
  "nameen": ""
}];

const initialStateArticle = [{
  "id" : "",
  "code" : "",
  "namees" : "",
  "nameen" : "",
  "saleprice" : 0, 
  "typeinside":true,
  "typeoutside" : true,
  "ticketweight": true,
  "enabled" : true, 
  "typesoftax_id":0,
  "typesoftax_namees": "",
  "typesoftax_nameen": "", 
  "codeler_id":0,
  "codeler_code": "" 
}];

            
const ArticlesFilter = ({typeOfList,showModalArticlesSettings,setShowModalArticlesSettings}) => {
  const {t,i18n} = useTranslation(['listDataArticles']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesizetickes);
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const DELETE_CODE_ARTICLE = useSelector((state) => state.formatDIUser.delete_code_formdi); 
  const filtersArticlesDetails = useSelector((state) => state.filtersArticles);
  const [dataArticle, setDataArticle] = useState(initialStateArticle);
  const [filtersArticle, setFiltersArticle]= useState(filtersArticlesDetails);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegArticle,setNumTotRegArticle]= useState(0);
  const [errorsFiltersArticle, setErrorsFiltersArticle] = useState({});
  const [inputTextArticle, setInputTextArticle] = useState("");
  const [openCreateDataArticle,setOpenCreateDataArticle]= useState(false);
  const [openDeleteRowArticle,setOpenDeleteRowArticle]= useState(false);
  const [openEditRowArticle,setOpenEditRowArticle]= useState(false);
  const [openEditFilterArticle,setOpenEditFilterArticle]= useState(false);
  const [rowEditArticle,setRowEditArticle]= useState(initialStateArticle[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorArticle, setIsLoadingErrorArticle] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const dispatch = useDispatch();
  const [activeOffsetArticle, setActiveOffsetArticle]= useState(false);
  const [currencyOffsetArticle, setCurrencyOffsetArticle] = useState(0);
  const [rangeOffsetArticle, setRangeOffsetArticle] = useState([{}]); 
  const [typesOfTaxesToSelect,setTypesOfTaxesToSelect]= useState(initialTypesOfTaxesToSelect);
  const [codeLERToSelect,setCodeLERToSelect]= useState(initialCodeLERToSelect); 

  const menuPermissions = useMemo(() => {
    const list = roles && roles[0] && roles[0].listmenus ? roles[0].listmenus : [];
    const has = (name) => list.some((m) => m.name === name);
    return {
      canCreate: has('SubMenu_Articles_Create'),
      canEdit: has('SubMenu_Articles_Edit'),
      canDelete: has('SubMenu_Articles_Delete')
    };
  }, [roles]);

  const navigate = useNavigate();

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalArticlesSettings) {
        setDataArticle(initialStateArticle); 
        setNumTotRegFilter(0);
        setNumTotRegArticle(0);
        setErrorsFiltersArticle({});
        setInputTextArticle("");
        setOpenCreateDataArticle(false);
        setOpenDeleteRowArticle(false);
        setOpenEditRowArticle(false);
        setOpenEditFilterArticle(false);
        setRowEditArticle(initialStateArticle[0]); 
        setIsLoadingErrorArticle(false);
        setIdCodeDelete(DELETE_CODE);
        setActiveOffsetArticle(false);
        setCurrencyOffsetArticle(0);
        setRangeOffsetArticle([{}]);
        setTypesOfTaxesToSelect(initialTypesOfTaxesToSelect);
        setCodeLERToSelect(initialCodeLERToSelect);
        setShowModalArticlesSettings(false);  
        dispatch(setLoading(false));
        dispatch(resetPagination());
        dispatch(resetFilters());
        setFiltersArticle(initialFiltersArticle);
        navigate(typeOfList==="1"?"/home":"/purchasedelivery");
        return () => {};
      }
    },
    [
      setDataArticle,
      setFiltersArticle,
      setNumTotRegFilter,
      setNumTotRegArticle,
      setErrorsFiltersArticle,
      setInputTextArticle,
      setOpenCreateDataArticle,
      setOpenDeleteRowArticle,
      setOpenEditRowArticle,
      setOpenEditFilterArticle,
      setRowEditArticle, 
      setIsLoadingErrorArticle,
      setIdCodeDelete,
      setActiveOffsetArticle,
      setCurrencyOffsetArticle,
      setRangeOffsetArticle,
      setTypesOfTaxesToSelect,
      setCodeLERToSelect, 
      showModalArticlesSettings,
      setShowModalArticlesSettings, 
      DELETE_CODE,
      typeOfList,
      dispatch,
      navigate]
  );

  const closeModalArticles = () => {    
    setDataArticle(initialStateArticle); 
    setNumTotRegFilter(0);
    setNumTotRegArticle(0);
    setErrorsFiltersArticle({});
    setInputTextArticle("");
    setOpenCreateDataArticle(false);
    setOpenDeleteRowArticle(false);
    setOpenEditRowArticle(false);
    setOpenEditFilterArticle(false);
    setRowEditArticle(initialStateArticle[0]); 
    setIsLoadingErrorArticle(false);
    setIdCodeDelete(DELETE_CODE);
    setActiveOffsetArticle(false);
    setCurrencyOffsetArticle(0);
    setRangeOffsetArticle([{}]);
    setTypesOfTaxesToSelect(initialTypesOfTaxesToSelect);
    setCodeLERToSelect(initialCodeLERToSelect);
    setShowModalArticlesSettings(false);  
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersArticle(initialFiltersArticle);
    navigate(typeOfList==="1"?"/home":"/purchasedelivery");
    return () => {};
  };

  
  const openCreateOrEditDataArticle = () => {
    setInputTextArticle("");
    setOpenCreateDataArticle(true);
    navigate("/articledetail/0");
  };

  const openEditFiltersArticle = () => {
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const handleSubmitFilterEditArticle = () => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    if (Object.keys(errorsFiltersArticle).length === 0) {
      setErrorsFiltersArticle({}); 
      dispatch(resetPagination());
      dispatch(setFilters(filtersArticle));     
      setOpenEditFilterArticle(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }

  const handleDeleteFiltersArticle = () => {
    setErrorsFiltersArticle({});
    dispatch(resetFilters());
    dispatch(resetPagination()); 
    setFiltersArticle(initialFiltersArticle); 
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const handleCancelFiltersArticle = () => {
    setErrorsFiltersArticle({}); 
    setOpenEditFilterArticle(!openEditFilterArticle);
  };   

  const handleChangeInsideFilter = (e) => {
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      typeinside: !filtersArticle.typeinside
    }));
  };

  const handleChangeOutsideFilter = (e) => {
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      typeoutside: !filtersArticle.typeoutside
    }));
  };


  const handleChangeWeightFilter = (e) => {
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      ticketweight: !filtersArticle.ticketweight
    }));
  };

  const handleChangeNotWeightFilter = (e) => {
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      tickenotweight: !filtersArticle.tickenotweight
    }));
  };


  const handleChangeEnabledFilter = (e) => {
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      enabled: !filtersArticle.enabled
    }));
  };

  const handleChangeNotEnabledFilter = (e) => {
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      notenabled: !filtersArticle.notenabled
    }));
  };

  const handleChangeFilterEditArticle = (e) => {
    const { name, value } = e.target;
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      [name]: value
    }));
  };

  const handleBlurFilterEditArticle = (e) => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    handleChangeFilterEditArticle(e);
  };

  const toggleDrawerFilterEditArticle = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditArticle();
    }
  };

  const validateFormFilterArticle = () => {

    let errorsFiltersArticle = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersArticle.idFrom!=="" & !regexNumber.test(filtersArticle.idFrom)) {
      errorsFiltersArticle.idFrom = 'Text_TextNoNumber';
    }
    if (filtersArticle.idTo!=="" & !regexNumber.test(filtersArticle.idTo)) {
      errorsFiltersArticle.idTo = 'Text_TextNoNumber';
    }
    if (filtersArticle.idFrom!=="" & !errorsFiltersArticle.idFrom!==undefined){
      if (filtersArticle.idTo!=="" & !errorsFiltersArticle.idTo!==undefined){
        if (parseInt(filtersArticle.idTo)<parseInt(filtersArticle.idFrom)){
          errorsFiltersArticle.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersArticle.codeFrom)) {
      errorsFiltersArticle.codeFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeTo)) {
      errorsFiltersArticle.codeTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameesFrom)) {
      errorsFiltersArticle.nameesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameesTo)) {
      errorsFiltersArticle.nameesTo = 'Text_TextNoValid';
    } 

    if (regexInvalidCharacters.test(filtersArticle.nameenFrom)) {
      errorsFiltersArticle.nameenFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameenTo)) {
      errorsFiltersArticle.nameenTo = 'Text_TextNoValid';
    } 

    if (filtersArticle.codeTo!=="" & filtersArticle.codeTo<filtersArticle.codeFrom){
      errorsFiltersArticle.codeTo = 'Text_TextGreater_Code';
    }
   
    if (filtersArticle.nameesTo!=="" & filtersArticle.nameesTo<filtersArticle.nameesFrom){
      errorsFiltersArticle.nameesTo = 'Text_TextGreater_Namees';
    }

    if (filtersArticle.nameenTo!=="" & filtersArticle.nameenTo<filtersArticle.nameenFrom){
      errorsFiltersArticle.nameenTo = 'Text_TextGreater_Nameen';
    } 
    
    if (filtersArticle.typesoftaxToES!=="" & filtersArticle.typesoftaxToES<filtersArticle.typesoftaxFromES){
      filtersArticle.typesoftaxToES="";
      errorsFiltersArticle.typesoftaxToES = 'Text_TextGreater_TypesOfTax';
    }    
    if (filtersArticle.typesoftaxToEN!=="" & filtersArticle.typesoftaxToEN<filtersArticle.typesoftaxFromEN){
        filtersArticle.typesoftaxToEN="";
        errorsFiltersArticle.typesoftaxToEN = 'Text_TextGreater_TypesOfTax';
    }
 
    if (filtersArticle.codelerTo!=="" & filtersArticle.phonesTo<filtersArticle.codelerFrom){
      errorsFiltersArticle.codelerTo = 'Text_TextGreater_CodeLer';
    }
 
    return errorsFiltersArticle;
  }  

  const filteredDataArticle = dataArticle.filter((el) => {
    if (inputTextArticle === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.code || '') +
        String(el.namees || '') +
        String(el.nameen || '') + 
        String(el.codeler_code || '');
      let result = dataTranslate.toLowerCase().includes(inputTextArticle.toLowerCase());
      return result;
    }
  })

  let inputHandlerArticle = (e) => {
      var lowerCase = e.target.value.toLowerCase();
      setInputTextArticle(lowerCase);
  };

  const handleChangeDeleteRowArticle = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRowArticle = () => {
    setRowEditArticle(initialStateArticle[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorArticle(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowArticle(false);
  };
 
  const handleCloseDeleteRowArticle = (e) => {
    if (idCodeDelete !== DELETE_CODE_ARTICLE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    } 
    if (e.key !== 'Escape') {
      if (rowEditArticle.id !== '') {
     
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `article/deletearticle`, token, rowEditArticle);
            if (getData.status === "OK") {
              dispatch(successErrorAction(t('Text_ValidCode')));
              dispatch(successErrorAction(t('Text_DeleteField')));
              dispatch(setLoading(false));
            } else {
              dispatch(setLoading(false));
              dispatch(warningErrorAction(t(getData.cause))); 
            }
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }  
        };
        fetchData(); 
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowArticle(false);
    setIsLoadingErrorArticle(false);
    handleCloseDataEditArticle();
    return () => {};
  };
 

  const handleCloseDataEditArticle = () => {
    setOpenCreateDataArticle(false);
    setOpenEditRowArticle(false);
    setRowEditArticle(openEditRowArticle?rowEditArticle:initialStateArticle[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorArticle(false);
    toggleDrawerFilterEditArticle(false);
	};

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
 
  useEffect(() => {
    if (numTotRegArticle > LIMITPAGESIZE) {
      setActiveOffsetArticle(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMITPAGESIZE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMITPAGESIZE); i < numTotRegArticle; i += Number(LIMITPAGESIZE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMITPAGESIZE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetArticle(newRangeOffset);
    } else {
      setCurrencyOffsetArticle(0);
      setActiveOffsetArticle(false);
      setRangeOffsetArticle([{}]);
    }
  }, [numTotRegArticle, LIMITPAGESIZE]);

  useEffect(() => {
    let isMounted = true;
    const fetchDataTypesOfTaxes = async () => {
      try {
        const getData = i18n.language === "es"
        ? await helpHttp().get(ENDPOINT, `article/typesoftaxesorderbynamees`, token)
        : await helpHttp().get(ENDPOINT, `article/typesoftaxesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setTypesOfTaxesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataCodeLER = async () => {
      try {
        const getData =   await helpHttp().get(ENDPOINT, `article/codelersorderbycode`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          dispatch(setLoading(false));
        } else if (isMounted) {
          setCodeLERToSelect(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (showModalArticlesSettings){
      fetchDataCodeLER();
      fetchDataTypesOfTaxes(); 
      return () => { isMounted = false; };
    }
  }, [t,token,dispatch,i18n.language,showModalArticlesSettings]);


  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegArticle = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `article/getinformationtablearticle`, token);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataArticle(initialStateArticle);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else {
          setNumTotRegArticle(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchnumTotRegFilter = async () => {
      try {
        const getData = await helpHttp().post(ENDPOINT, `article/getcountfilterarticle`, token, filtersArticlesDetails);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataArticle(initialStateArticle);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    }; 
     
    const fetchDataArticle = async () => {
      dispatch(setLoading(true));
      try { 
          const getData = await helpHttp().get3(ENDPOINT, `article/getarticles`, token, currencyOffsetArticle, LIMITPAGESIZE, filtersArticlesDetails);
        if (getData.err || getData.message === "Load failed") {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else {
          setDataArticle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    }; 
    if (showModalArticlesSettings){
      fetchnumTotRegArticle();
      fetchnumTotRegFilter();  
      fetchDataArticle();
      return () => { isMounted = false; };
    }
  }, [t,token,dispatch,i18n.language,openCreateDataArticle,openDeleteRowArticle,setOpenDeleteRowArticle,setOpenEditRowArticle,openEditRowArticle,rowEditArticle,showModalArticlesSettings,LIMITPAGESIZE,numTotRegFilter,filtersArticlesDetails,currencyOffsetArticle]);

  return (
    <>
      {showModalArticlesSettings ? ( 
        <div className="container-fluid formdi-pending-page">
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingErrorArticle?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRowArticle?"warning":"primary"}/>:<i className="fas fa-shop text-warning"></i>} {t('Text_Articles_Table')}
            </h1>
            {isLoadingData ?
              <CircularProgress sx={{ color : "#f6c23e"}}/>:
                <>
                 {menuPermissions.canCreate?
                  <div>
                    <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditDataArticle} >
                      {t('Button_Create')}
                    </button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalArticles} >
                        {t('Button_Back')}
                      </button> 
                  </div>:
                   <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalArticles} >
                    {t('Button_Back')}
                  </button> 
                } 
                </>
            } 
          </div>  
          <br/>   
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputTextArticle}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_Article_Search')} 
              onChange={inputHandlerArticle}
              fullWidth
              label={t('Text_Article_Search')}>
            </TextField>
          </div> 
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${(filtersArticlesDetails.codeFrom!=="" || filtersArticlesDetails.codeTo!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                <span className={`formdi-pending-dot ${(filtersArticlesDetails.codeFrom!=="" || filtersArticlesDetails.codeTo!=="")? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersArticlesDetails.nameesFrom!=="" || filtersArticlesDetails.nameesTo!=="" || filtersArticlesDetails.nameenFrom!=="" || filtersArticlesDetails.nameenTo!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                <span className={`formdi-pending-dot ${(filtersArticlesDetails.nameesFrom!=="" || filtersArticlesDetails.nameesTo!=="" || filtersArticlesDetails.nameenFrom!=="" || filtersArticlesDetails.nameenTo!=="")? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Name")}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersArticlesDetails.typeinside || filtersArticlesDetails.typesoftaxFromES!=="" || filtersArticlesDetails.typesoftaxToES!=="" || filtersArticlesDetails.typesoftaxFromEN!=="" || filtersArticlesDetails.typesoftaxToEN!=="" || filtersArticlesDetails.codelerFrom!=="" || filtersArticlesDetails.codelerTo!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                <span className={`formdi-pending-dot ${(filtersArticlesDetails.typeinside || filtersArticlesDetails.typesoftaxFromES!=="" || filtersArticlesDetails.typesoftaxToES!=="" || filtersArticlesDetails.typesoftaxFromEN!=="" || filtersArticlesDetails.typesoftaxToEN!=="" || filtersArticlesDetails.codelerFrom!=="" || filtersArticlesDetails.codelerTo!=="")? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Others_Filters")}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersArticlesDetails.tickenotweight || filtersArticlesDetails.typeoutside)? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                <span className={`formdi-pending-dot ${(filtersArticlesDetails.tickenotweight || filtersArticlesDetails.typeoutside)? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Outside")}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersArticlesDetails.ticketweight)? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                <span className={`formdi-pending-dot ${(filtersArticlesDetails.ticketweight)? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Weight")}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersArticlesDetails.enabled)? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                <span className={`formdi-pending-dot ${(filtersArticlesDetails.enabled)? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_enabled")}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersArticlesDetails.notenabled)? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                <span className={`formdi-pending-dot ${(filtersArticlesDetails.notenabled)? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_NOT_enabled")}
              </button>
               
            </div>
          </div>
          <br/> 
          {!isLoadingData ?
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingArticle
                    dataArticle={filteredDataArticle}
                    numTotRegFilter={ numTotRegFilter}
                    titleTable={t('Text_Articles_Table')}
                    setOpenDeleteRowArticle={setOpenDeleteRowArticle}
                    setRowEditArticle={setRowEditArticle}
                    showEditButtonArticle={menuPermissions.canEdit}
                    showDeleteButtonArticle={menuPermissions.canDelete}
                    numTotRegArticle={numTotRegArticle}
                    activeOffsetArticle={activeOffsetArticle}
                    rangeOffsetArticle={rangeOffsetArticle}
                    currencyOffsetArticle={currencyOffsetArticle}
                    setCurrencyOffsetArticle={setCurrencyOffsetArticle} 
                    minvalue={Number(NON_ERASABLE_ARTICLES_ID)} 
                  > 
                  </TableSortingArticle>
                </div>             
              </div>
              {openEditFilterArticle &&
               <div>
               <SwipeableDrawer
                 anchor='right'
                 open={true}
                 onClose={toggleDrawerFilterEditArticle(false)}
                 onOpen={toggleDrawerFilterEditArticle(true)}>
                 <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                     <br/>
                       <div id="myDIV">
                         <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                       </div>
                       <hr className="sidebar-divider d-none d-md-block"/>
                       <form className="createfilterarticle" onSubmit={handleCancelFiltersArticle}>  
                         <div className="form-floating mb-3 px-4 primary"> 
                           <div className="form-group">
                             <TextField
                               id="codeFrom" 
                               name="codeFrom"
                               value={filtersArticle.codeFrom}
                               inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                               InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                               label={errorsFiltersArticle.codeFrom!=null?t(errorsFiltersArticle.codeFrom):t('Text_Filter_Code_From')}
                               placeholder={t('PlaceHolder_Filter_Code_From')}
                               variant="outlined"
                               onBlur={handleBlurFilterEditArticle}
                               onChange={handleChangeFilterEditArticle}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                               id="codeTo" 
                               name="codeTo"
                               value={filtersArticle.codeTo}
                               inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                               InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                               label={errorsFiltersArticle.codeTo!=null?t(errorsFiltersArticle.codeTo):t('Text_Filter_Code_To')}
                               placeholder={t('PlaceHolder_Filter_Code_To')}
                               variant="outlined"
                               onBlur={handleBlurFilterEditArticle}
                               onChange={handleChangeFilterEditArticle}/>
                           </div> 
                           <div className="form-group">
                             <TextField
                               id="nameesFrom" 
                               name="nameesFrom"
                               value={filtersArticle.nameesFrom}
                               inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                               InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                               label={errorsFiltersArticle.nameesFrom!=null?t(errorsFiltersArticle.nameesFrom):t('Text_Filter_Namees_From')}
                               placeholder={t('PlaceHolder_Filter_Namees_From')}
                               variant="outlined"
                               onBlur={handleBlurFilterEditArticle}
                               onChange={handleChangeFilterEditArticle}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                               id="nameesTo" 
                               name="nameesTo"
                               value={filtersArticle.nameesTo}
                               inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                               InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                               label={errorsFiltersArticle.nameesTo!=null?t(errorsFiltersArticle.nameesTo):t('Text_Filter_Namees_To')}
                               placeholder={t('PlaceHolder_Filter_Namees_To')}
                               variant="outlined"
                               onBlur={handleBlurFilterEditArticle}
                               onChange={handleChangeFilterEditArticle}/>
                           </div>

                           <div className="form-group">
                             <TextField
                               id="nameenFrom" 
                               name="nameenFrom"
                               value={filtersArticle.nameenFrom}
                               inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                               InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                               label={errorsFiltersArticle.nameenFrom!=null?t(errorsFiltersArticle.nameenFrom):t('Text_Filter_Nameen_From')}
                               placeholder={t('PlaceHolder_Filter_Nameen_From')}
                               variant="outlined"
                               onBlur={handleBlurFilterEditArticle}
                               onChange={handleChangeFilterEditArticle}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                               id="nameenTo" 
                               name="nameenTo"
                               value={filtersArticle.nameenTo}
                               inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                               InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                               label={errorsFiltersArticle.nameenTo!=null?t(errorsFiltersArticle.nameenTo):t('Text_Filter_Nameen_To')}
                               placeholder={t('PlaceHolder_Filter_Nameen_To')}
                               variant="outlined"
                               onBlur={handleBlurFilterEditArticle}
                               onChange={handleChangeFilterEditArticle}/>
                           </div>
                            
                            <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                              <div className="form-group">
                                <TextField
                                  id={i18n.language==="es"?"typesoftaxFromES":"typesoftaxFromEN"}
                                  name={i18n.language==="es"?"typesoftaxFromES":"typesoftaxFromEN"}
                                  value={i18n.language==="es"?filtersArticle.typesoftaxFromES:filtersArticle.typesoftaxFromEN}
                                  inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  label={i18n.language==="es"?errorsFiltersArticle.typesoftaxFromES!=null?t(errorsFiltersArticle.typesoftaxFromES):t('Text_Filter_TypeOfTax_From'):errorsFiltersArticle.typesoftaxFromEN!=null?t(errorsFiltersArticle.typesoftaxFromEN):t('Text_Filter_TypeOfTax_From')}
                                  placeholder={t('PlaceHolder_Filter_TypeOfTax_From')}
                                  variant="outlined"
                                  onBlur={handleBlurFilterEditArticle}
                                  onChange={handleChangeFilterEditArticle}
                                  select
                                  SelectProps={{
                                  native: true,
                                  }}>
                                  <option key={0} value=""/>
                                  {typesOfTaxesToSelect.map((option) => (
                                  <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                      {i18n.language==="es"?option.namees:option.nameen}
                                  </option>
                                  ))}
                                </TextField>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <TextField
                                    id={i18n.language==="es"?"typesoftaxToES":"typesoftaxToEN"}
                                    name={i18n.language==="es"?"typesoftaxToES":"typesoftaxToEN"}
                                    value={i18n.language==="es"?filtersArticle.typesoftaxToES:filtersArticle.typesoftaxToEN}
                                    inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={i18n.language==="es"?errorsFiltersArticle.typesoftaxToES!=null?t(errorsFiltersArticle.typesoftaxToES):t('Text_Filter_TypeOfTax_To'):errorsFiltersArticle.typesoftaxToEN!=null?t(errorsFiltersArticle.typesoftaxToEN):t('PlaceHolder_Filter_TypeOfTax_To')}
                                    placeholder={t('PlaceHolder_Filter_TypeOfTax_To')}
                                    variant="outlined"
                                    onBlur={handleBlurFilterEditArticle}
                                    onChange={handleChangeFilterEditArticle}
                                    select
                                    SelectProps={{
                                    native: true,
                                    }}>
                                    <option key={0} value=""/>
                                    {typesOfTaxesToSelect.filter(item=>(i18n.language==="es"?item.namees>=filtersArticle.typesoftaxFromES:item.nameen>=filtersArticle.typesoftaxFromEN)).map(option => (
                                    <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                        {i18n.language==="es"?option.namees:option.nameen}
                                    </option>
                                    ))}
                                </TextField>
                              </div>

                              <div className="form-group">
                                <TextField
                                  id={"codelerFrom"}
                                  name={"codelerFrom"}
                                  value={filtersArticle.codelerFrom}
                                  inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  label={errorsFiltersArticle.codelerFrom!=null?t(errorsFiltersArticle.codelerFrom):t('Text_Filter_CodeLER_From')}
                                  placeholder={t('PlaceHolder_Filter_CodeLER_From')}
                                  variant="outlined"
                                  onBlur={handleBlurFilterEditArticle}
                                  onChange={handleChangeFilterEditArticle}
                                  select
                                  SelectProps={{
                                  native: true,
                                  }}>
                                  <option key={0} value=""/>
                                  {codeLERToSelect.map((option) => (
                                  <option key={option.id} value={option.code}>
                                      {option.code} - {i18n.language==="es"?option.namees:option.nameen}
                                  </option>
                                  ))}
                                </TextField>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <TextField
                                    id={"codelerTo"}
                                    name={"codelerTo"}
                                    value={filtersArticle.codelerTo}
                                    inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsFiltersArticle.codelerTo!=null?t(errorsFiltersArticle.codelerTo):t('Text_Filter_CodeLER_To')}
                                    placeholder={t('PlaceHolder_Filter_CodeLER_To')}
                                    variant="outlined"
                                    onBlur={handleBlurFilterEditArticle}
                                    onChange={handleChangeFilterEditArticle}
                                    select
                                    SelectProps={{
                                    native: true,
                                    }}>
                                    <option key={0} value=""/>
                                    {codeLERToSelect.filter(item=>(item.code>=filtersArticle.codelerFrom)).map(option => (
                                    <option key={option.id} value={option.code}>
                                        {option.code} - {i18n.language==="es"?option.namees:option.nameen}
                                    </option>
                                    ))}
                                </TextField>
                              </div>

                            </Suspense>
                            <div className="form-group">
                              <Checkbox
                                id="typeinside" 
                                name="typeinside"
                                checked={filtersArticle.typeinside}
                                onChange={handleChangeInsideFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Inside')}</label>  
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                id="typeoutside" 
                                name="typeoutside"
                                checked={filtersArticle.typeoutside}
                                onChange={handleChangeOutsideFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Outside')}</label>    
                            </div>
                            <div className="form-group"> 
                              <Checkbox
                                id="ticketweight" 
                                name="ticketweight"
                                checked={filtersArticle.ticketweight}
                                onChange={handleChangeWeightFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Weight')}</label>  
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                id="tickenotweight" 
                                name="tickenotweight"
                                checked={filtersArticle.tickenotweight}
                                onChange={handleChangeNotWeightFilter}
                                variant="standard"
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                  }}
                                />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Not_Weight')}</label>    
                            </div>
                            <div className="form-group">  
                              <Checkbox
                                id="enabled" 
                                name="enabled"
                                checked={filtersArticle.enabled}
                                onChange={handleChangeEnabledFilter}
                                variant="standard"
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                  }}
                                />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Habilty')}</label>  
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                id="notenabled" 
                                name="notenabled"
                                checked={filtersArticle.notenabled}
                                onChange={handleChangeNotEnabledFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Not_Habilty')}</label>   
                            </div>
                         </div>
                         <hr className="sidebar-divider d-none d-md-block" />
                        <div className="formdi-pending-action-group">
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditArticle}>
                            {t('Button_Apply')}
                          </button> 
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersArticle}>
                            {t('Button_Cancel_Filters')}
                          </button>
                        </div>
                     </form>
                   </Box>
                 </Container>
               </SwipeableDrawer>
             </div>
            }  
            <Dialog open={openDeleteRowArticle} onClose={handleCancelDeleteRowArticle} PaperProps={{ className: "my-dialog-paper-danger" }} >
              <DialogTitle className="my-dialog-title-danger">
                {t('Text_Delete')} {rowEditArticle.id}  - {rowEditArticle.code} - {i18n.language==='es'?rowEditArticle.namees:rowEditArticle.nameen}
              </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="idCode"
                      label={t("Text_Label")}
                      type="text"
                      fullWidth
                      variant="standard"
                      className="my-dialog-input-danger"
                      defaultValue={idCodeDelete}
                      onChange={handleChangeDeleteRowArticle}
                    />
                  </DialogContent>
                <DialogActions className="my-dialog-actions">
                <Button
                  onClick={handleCancelDeleteRowArticle}
                  className="my-dialog-button-cancel-danger"
                >
                  {t("Button_Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCloseDeleteRowArticle}
                  className="my-dialog-button-delete"
                >
                  {t("Button_Delete")}
                </Button>
              </DialogActions>
            </Dialog>   
            {/* End Content Row */}
          </>:
            <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

ArticlesFilter.propTypes = {
  typeOfList: PropTypes.string.isRequired,
  showModalArticlesSettings: PropTypes.bool.isRequired,
  setShowModalArticlesSettings: PropTypes.func.isRequired 
};

export default ArticlesFilter;
